import { images } from "../constants";

const home = [
    { 
        id: 1,
        image: images.home1,
        subtitle: "Welcome to SwiftRide",
        headingPart1: "Reliable",
        spanText: "Taxi Services",
        headingPart2: "Anytime, Anywhere",
        buttonText: "Book a Ride",
        buttonLink: "Booking",
    },
    {
        id: 2,
        image: images.home2,
        subtitle: "Welcome to SwiftRide",
        headingPart1: "Quick",
        spanText: "Pickups",
        headingPart2: "and Safe Rides",
        buttonText: "Book a Ride",
        buttonLink: "Booking",
    },
    {
        id: 3,
        image: images.home3,
        subtitle: "Welcome to SwiftRide",
        headingPart1: "Comfortable",
        spanText: "Rides",
        headingPart2: "at Affordable Prices",
        buttonText: "Book a Ride",
        buttonLink: "Booking",
    },
];

export default home;